<template>
  <div class="list">
    <div class="item" v-for="item in listData">
      <div class="main" @click="toDetail(item)">
        <!--      按策略-->
        <template>
          <p class="name">{{ item.strategyName }}</p>
          <div class="num-list">
            <div class="num-item">
              <span class="label">运行中</span>
              <span class="line"></span>
              <span class="num">{{ item.running }}</span>
            </div>
            <div class="num-item">
              <span class="label">启动中</span>
              <span class="line"></span>
              <span class="num">{{ item.starting }}</span>
            </div>
            <div class="num-item">
              <span class="label">停止中</span>
              <span class="line"></span>
              <span class="num">{{ item.stopping }}</span>
            </div>
            <div class="num-item">
              <span class="label">已停止</span>
              <span class="line"></span>
              <span class="num">{{ item.shutdown }}</span>
            </div>
          </div>
          <div class="tips" v-if="item.strategyId == 3">提示：交易日00:00-08:00以及非交易日，即使策略在运行中，策略在这个时间不会执行</div>
        </template>
        <!--      按账号 -->
        <template>

        </template>
      </div>
      <div class="btn-wrap">
        <div class="btn-item run" :class="{dis: item.shutdown == 0}" @click="run(item)">全部运行</div>
        <div class="btn-item stop" :class="{dis: item.running == 0}" @click="stop(item)">全部停止</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    listData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toDetail(item){
      this.$emit("toDetail", item);
    },
    run(item){
      if(item.shutdown && item.shutdown > 0){
        this.$emit("run", item);
      }
    },
    stop(item){
      if(item.running && item.running > 0){
        this.$emit("stop", item);
      }
    }
  }
}
</script>


<style scoped lang="less">
.list{
  padding: 0 32px;
  overflow: hidden;
  .item{
    margin-bottom: 45px;
    .main{
      border: #eee solid 1px;
      border-radius: 20px;
      padding: 25px 32px 30px;
      .name{
        font-size: 30px;
        font-weight: bold;
      }
      .num-list{
        display: flex;
        margin-top: 20px;
        justify-content: space-between;
        .num-item{
          width: 110px;
          margin-left: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 130px;
          line-height: 1;
          color: #fff;
          border-radius: 10px;
          .label{
            font-size: 24px;
          }
          .line{
            height: 1px;
            width: 120%;
            transform: scale(0.5);
            background: #eee;
            margin: 15px 0 10px;
            opacity: 0.6;
          }
          .num{
            font-size: 30px;
            font-weight: bold;
          }
          &:nth-child(1){
            margin-left: 0;
            background: #02AA39;
          }
          &:nth-child(2){
            background: #F69500;
          }
          &:nth-child(3){
            background: #888;
          }
          &:nth-child(4){
            background: #EB3323;
          }
        }
      }
      .tips {
        color: #EB3323;
        font-size: 23px;
        margin-top: 10px;
      }
    }
    .btn-wrap{
      display: flex;
      margin-top: 20px;
      padding: 0 60px;
      .btn-item{
        flex: 1;
        text-align: center;
        height: 70px;
        line-height: 65px;
        font-size: 28px;
        font-weight: 500;
        margin-left: 100px;
        border-radius: 10px;
        box-sizing: border-box;
        &:nth-child(1){
          margin-left: 0;
        }
        &.run{
          color: #02AA39;
          border: #02AA39 solid 1px;
        }
        &.stop{
          color: #EB3323;
          border: #EB3323 solid 1px;
        }
        &.dis{
          color: #999;
          border-color: #999;
        }
      }
    }
  }
}
</style>
